/**
 * rondo-web-forms
 *
 * Rondo Web Forms
 *
 * @author Jiri Hybek <jiri@hybek.cz>
 * @license See LICENSE file distributed with this source code.
 */

import React from "react";

import { bem } from "../../../shared/BEM";

/**
 * Component props
 */
export interface INewsComponentProps {
	children: any;
}

/**
 * News
 *
 * @param props Component props
 */
export function News(props: INewsComponentProps) {

	const stl = bem("menu-news");

	return <div className={stl.str}>
		<header className={stl.el("header").str}>
			<h2 className={stl.el("header-title").str}>Přehled novinek</h2>
		</header>
		<section className={stl.el("content").str}>
			{props.children}
		</section>
	</div>;

}
